import {
  getBaggageQty,
  getVehicleTransmissionLabel,
} from "@apac/components/cars";
import { IconNameEnum } from "@b2bportal/core-themes";
import type { Vehicle } from "@b2bportal/ground-api";
import type { TFunction } from "i18next";

export const CAR_LIST_SORT_ICON = IconNameEnum.sort;

// Show all cars in a store in map view store cars list pop up
export const CAR_LIST_STORE_PREVIEW_COUNT = Number.MAX_SAFE_INTEGER;

export const HIGHLIGHTED_CAR_SPECS = [
  {
    key: "passenger",
    iconName: IconNameEnum.user,
    getText: (t: TFunction, vehicle: Vehicle) =>
      vehicle?.passengerQty > 0
        ? t("apac.cars.specifications.passengers_qty", {
            count: vehicle.passengerQty,
          })
        : null,
  },
  {
    key: "transmission",
    iconName: IconNameEnum.filter,
    getText: (t: TFunction, vehicle: Vehicle) =>
      getVehicleTransmissionLabel(t, vehicle.transmissionType),
  },
  {
    key: "bags",
    iconName: IconNameEnum.luggage,
    getText: (t: TFunction, vehicle: Vehicle) => {
      const count = getBaggageQty(vehicle);
      if (count < 1) return undefined;
      return t("core-cars.vehicleAttributes.bags", {
        count,
      });
    },
  },
  {
    key: "aricon",
    iconName: IconNameEnum.airConditioning,
    getText: (t: TFunction, vehicle: Vehicle) =>
      vehicle.airConditioning
        ? t("core-cars.vehicleAttributes.airConditioning")
        : null,
  },
];
